var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fade-in"},[_c('h1',{staticClass:"display-4 font-weight-lighter"},[_vm._v("Invite Contacts")]),_c('customer-contact-table',{attrs:{"filters":{invited: false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }